'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { useWindowScroll } from '@hooks';
import { QuickNav, type QuickNavSection } from './quick-nav';

/** Offset in pixels before the gallery bottom to trigger quick nav visibility */
const GALLERY_VISIBILITY_OFFSET = 100;
interface ListingQuickNavProps {
  sections: QuickNavSection[];
}
export const ListingQuickNav: React.FC<ListingQuickNavProps> = t0 => {
  const $ = _c(6);
  const {
    sections
  } = t0;
  const {
    y: scrollY
  } = useWindowScroll();
  const [isVisible, setIsVisible] = React.useState(false);
  let t1;
  let t2;
  if ($[0] !== scrollY) {
    t1 = () => {
      const gallery = document.getElementById("photos");
      if (!gallery) {
        setIsVisible(false);
        return;
      }
      const galleryBottom = gallery.offsetTop + gallery.offsetHeight;
      setIsVisible(scrollY > galleryBottom - GALLERY_VISIBILITY_OFFSET);
    };
    t2 = [scrollY];
    $[0] = scrollY;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  React.useEffect(t1, t2);
  let t3;
  if ($[3] !== isVisible || $[4] !== sections) {
    t3 = <QuickNav sections={sections} isVisible={isVisible} />;
    $[3] = isVisible;
    $[4] = sections;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};